export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10659.96898e23.jpg";